import { serverUrl as apiServerUrl } from "../../utils/server-url";

export const APP_CONFIG = {
  NAME: "OS04",
  VERSION: "1.0.0",
  DESCRIPTION: "Construction site management platform",
} as const;

export const UI_CONSTANTS = {
  ANIMATION_DURATION: 300,
  DEBOUNCE_DELAY: 500,
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
} as const;

const DEFAULT_PUBLIC_APP_HOST = "dashboard.os04.app";

function isLocalHostname(hostname: string) {
  return hostname === "localhost" || hostname === "127.0.0.1";
}

export function derivePublicAppHost(serverUrl?: string) {
  if (!serverUrl) {
    return DEFAULT_PUBLIC_APP_HOST;
  }

  try {
    const { hostname } = new URL(serverUrl);

    if (hostname === "api.os04.app") {
      return "dashboard.os04.app";
    }

    if (hostname === "staging.api.os04.app") {
      return "staging.dashboard.os04.app";
    }

    if (isLocalHostname(hostname)) {
      return hostname;
    }

    return DEFAULT_PUBLIC_APP_HOST;
  } catch {
    return DEFAULT_PUBLIC_APP_HOST;
  }
}

function createSigninUrlRegex(hostname: string, pathname: string) {
  const escapedHostname = hostname.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const protocol = isLocalHostname(hostname) ? "https?" : "https";
  const portPattern = isLocalHostname(hostname) ? "(?::\\d+)?" : "";

  return new RegExp(
    `^${protocol}://${escapedHostname}${portPattern}${pathname}/[^/]+$`
  );
}

// QR code configuration using environment variables for futureproofing
export const QR_CONFIG = {
  DOMAIN: derivePublicAppHost(apiServerUrl),

  // URL path pattern for worker sign-in (public route encoded in QR codes)
  SITE_SIGNIN_PATH_PATTERN: "/site-signin" as const,
  ENTRANCE_SIGNIN_PATH_PATTERN: "/entrance-signin" as const,
} as const;

export const STONECUT_WORKER_SIGNIN_URL_REGEX = createSigninUrlRegex(
  QR_CONFIG.DOMAIN,
  QR_CONFIG.SITE_SIGNIN_PATH_PATTERN
);

export const STONECUT_ENTRANCE_SIGNIN_URL_REGEX = createSigninUrlRegex(
  QR_CONFIG.DOMAIN,
  QR_CONFIG.ENTRANCE_SIGNIN_PATH_PATTERN
);
